import React from 'react';

import { MenuIconWithLabel, MenuIconContainer, MenuIconLabel } from './iconInCircleWithLabel.styled';
import { IconInCircleWithLabelData } from './iconInCircleWithLabel.types';

export const IconInCircleWithLabel: React.FC<IconInCircleWithLabelData> = (data: IconInCircleWithLabelData) => {
  const { label, onClick, className, children } = data;

  const handleClick = (): void => onClick();

  return (
    <MenuIconWithLabel className={className}>
      <MenuIconContainer onClick={handleClick}>
        {children}
      </MenuIconContainer>
      <MenuIconLabel>{label}</MenuIconLabel>
    </MenuIconWithLabel>
  );
}
